import { render, staticRenderFns } from "./CompList.vue?vue&type=template&id=03d5bbde&scoped=true"
import script from "./CompList.vue?vue&type=script&lang=js"
export * from "./CompList.vue?vue&type=script&lang=js"
import style0 from "./CompList.vue?vue&type=style&index=0&id=03d5bbde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5bbde",
  null
  
)

export default component.exports